import * as types from '../../lib/actionTypes.es6';

const initialState = {
  loader: false,
  iprs_configs: null,
  get_configs_error: null,

  config_raw_loader: false,
  iprs_config_raw: null,
  get_config_raw_error: null,

  publish_loader: false,
  successfully_published: null,
  publish_error: null,

  create_loader: false,
  successfully_created: null,
  create_error: null,
};

export default function iprsConfigsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_IPRS_CONFIGS_REQUEST:
      return { ...state, loader: true, get_configs_error: null };
    case types.GET_IPRS_CONFIGS_SUCCESS:
      return { ...state, loader: false, iprs_configs: action.payload, get_configs_error: null };
    case types.GET_IPRS_CONFIGS_FAIL:
      return { ...state, loader: false, get_configs_error: action.payload };

    case types.GET_IPRS_CONFIG_RAW_REQUEST:
      return { ...state, config_raw_loader: true, iprs_config_raw: null, get_config_raw_error: null };
    case types.GET_IPRS_CONFIG_RAW_SUCCESS:
      return { ...state, config_raw_loader: false, iprs_config_raw: action.payload, get_config_raw_error: null };
    case types.GET_IPRS_CONFIG_RAW_FAIL:
      return { ...state, config_raw_loader: false, get_config_raw_error: action.payload };
    case types.GET_IPRS_CONFIG_RAW_RESET:
      return { ...state, iprs_config_raw: null, get_config_raw_error: null };

    case types.PUBLISH_IPRS_CONFIG_REQUEST:
      return { ...state, publish_loader: true, successfully_published: null, publish_error: null };
    case types.PUBLISH_IPRS_CONFIG_SUCCESS:
      return { ...state, publish_loader: false, successfully_published: action.payload, publish_error: null };
    case types.PUBLISH_IPRS_CONFIG_FAIL:
      return { ...state, publish_loader: false, successfully_published: null, publish_error: action.payload };
    case types.PUBLISH_IPRS_CONFIG_RESET:
      return { ...state, successfully_published: null, publish_error: null };

    case types.CREATE_IPRS_CONFIG_REQUEST:
      return { ...state, create_loader: true, successfully_created: null, create_error: null };
    case types.CREATE_IPRS_CONFIG_SUCCESS:
      return { ...state, create_loader: false, successfully_created: action.payload, create_error: null };
    case types.CREATE_IPRS_CONFIG_FAIL:
      return { ...state, create_loader: false, successfully_created: null, create_error: action.payload };
    case types.CREATE_IPRS_CONFIG_RESET:
      return { ...state, successfully_created: null, create_error: null };

    default:
      return state;
  }
}
